export default function useTranslations(translations) {
  return (key, replacements = {}) => {
    let value = translations[key] || key
    Object.entries(replacements).forEach(([k, v]) => {
      value = value.replace(`%{${k}}`, v)
    })
    return value
  }
}
